<template>
  <div>
    <div
      v-for="i in 2"
      :key="'skeleton-block-' + i"
      class="skeleton__loggedout"
    >
      <Skeleton
        class="skeleton__loggedout__header"
      />
      <Skeleton
        class="skeleton__loggedout__content"
        :shape="'rectangle'"
      />
      <div class="skeleton__loggedout__buttons">
        <Skeleton
          class="skeleton__loggedout__buttons__login"
          :shape="'rectangle'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'

export default {
  components: {
    Skeleton
  }
}
</script>
<style lang="scss">
.skeleton__loggedout {
  margin: 0;
  display: block;

  &__header.k-skeleton {
    background-color: $color__skeleton__primary;
    width: 9rem;
    height: 1.5rem;
    margin-bottom: .8rem;
  }

  &__content.k-skeleton {
    width: 100%;
    height: 2rem;
    margin-bottom: .5rem;
  }

  &__buttons {
    width: 100%;
    height: 3rem;
    padding: 0;

    &__login.k-skeleton {
      background-color: $color__skeleton__primary;
      width: 12rem;
      height: 2.5rem;
      float: right;
    }
  }
}
</style>
